import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import type { FirstSessionAlertBody } from '../alertHover.types'
import { firstSessionStyles } from './FirstSession.styles'
import { useTranslation } from 'react-i18next'

const FirstSessionBody: React.FC<{ body: FirstSessionAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body?.clientName) return null

  return (
    <Box sx={firstSessionStyles.root}>
      <Typography sx={firstSessionStyles.text}>
        {t('firstSession.message', { name: body.clientName })}
      </Typography>
    </Box>
  )
}

export default FirstSessionBody
